<navigation-control />
<measure-tool />
<tutorial-polygon />
<map-action />

@if ($filters()?.devices || $filters()?.landmarks) {
  <div class="filter-info-banner">
    <mat-icon>info</mat-icon>
    <!-- TODO: make it a generic component -->
    <p>
      {{ 'MAP.FILTERS_MESSAGE' | translate }}
      @if ($filters()?.devices) {
        {{ 'MAP.FILTERS_DEVICES' | translate }}
      }
      @if ($filters()?.devices && $filters()?.landmarks) {
        {{ 'COMMON.AND' | translate }}
      }
      @if ($filters()?.landmarks) {
        {{ 'MAP.FILTERS_LANDMARKS' | translate }}
      }
    </p>
  </div>
}

<div #mapRef id="map-container">
  <div #map id="map" class="mapboxgl-map map-gl"></div>
</div>
